import { useQuery } from '@tanstack/react-query';

import HeatmapSurchargeService from '~/services/HeatmapSurchargeService';

import { heatmapSurchargeQueryKeys } from './heatmapSurchargeQueryKeys';

export function useGetHeatmapSurchargeOffers(offerId?: string) {
  return useQuery({
    queryKey: heatmapSurchargeQueryKeys.offers(offerId),
    queryFn: ({ signal }) => HeatmapSurchargeService.getOffers(offerId, { signal }),
    retry: false,
  });
}
